import axios from 'axios';
import { DeliveryOrderModel } from 'app/edozvola/cases/delivery-order/model/delivery-order.model';

export const fetchDeliveryOrderView = async ({ signal, pagination, uuid }): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/cases/${uuid}/delivery-order-view?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const getDeliveryOrder = async (uuid): Promise<DeliveryOrderModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${uuid}/delivery-order`)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {})
  })
}

export const saveDeliveryOrder = async (caseUuid: string, deliveryOrder: DeliveryOrderModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/delivery-order`, deliveryOrder)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};
